import React, { useState } from "react";
import '../../assets/css/JoinedPlayerList.css';
import { useNavigate } from "react-router-dom";
import man from '../../assets/images/PlayerImage.png';
import CustomButton from "../../components/CustomButton";
import Layout from "../../layouts/Layout";
import message from '../../assets/images/messages.png';

const JoinedPlayerList = () => {
  const [isNotJoinedSubmission,setIsNotJoinedSubmission] = useState();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  }


const NotJoinedSubmission = () => {
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  const players = [
    { id: 1, name: "Jhon G", role: "Expert", avatar: "👷" },
    { id: 2, name: "Tony K", role: "Beginner", avatar: "👨‍🎓" },
  ];

  const toggleModal = () => {
    setIsNotJoinedSubmission(!isNotJoinedSubmission);
  };

  const handleCheckboxChange = (id) => {
    setSelectedPlayers((prev) =>
      prev.includes(id) ? prev.filter((playerId) => playerId !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => {
    toggleModal();
  };

  return (
    <div>
      {/* Trigger Button */}
      <button className="btn btn-primary" onClick={toggleModal}>
        Open Modal
      </button>

      {/* Modal */}
      {isNotJoinedSubmission && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{width:'100%'}}>
              <div className="modal-header">
                <h5 className="modal-title text-danger">Select who did not join court!</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={toggleModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {players.map((player) => (
                  <div key={player.id} className="d-flex align-items-center mb-3">
                    <span style={{ fontSize: "24px", marginRight: "10px" }}>{player.avatar}</span>
                    <div className="flex-grow-1">
                      <p className="mb-0">
                        <strong>{player.name}</strong> ({player.role})
                      </p>
                    </div>
                    <input
                      type="checkbox"
                      checked={selectedPlayers.includes(player.id)}
                      onChange={() => handleCheckboxChange(player.id)}
                      className="form-check-input"
                    />
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary w-100" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
 const onNotJoinedSubmission = () =>{
  setIsNotJoinedSubmission(true);
 }


  return (
<>
<Layout>
            <div className=" d-flex justify-content-between align-items-center">
              <div className="joined-back-button" onClick={handleBack} style={{ cursor:'pointer'}}>Back</div>
              <h4 className="text-center mb-0">Game Name</h4>
              <div className="joined-cancel-button" onClick={handleBack} style={{ cursor:'pointer'}}>Cancel</div>
            </div>

            <form className="mt-4">
              {/* Price Section */}
              <div className="mb-4">
                <label className="form-label">Price</label>
                <div className="d-flex">
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="price"
                      id="free"
                      value="free"
                    />
                    <label className="form-check-label" htmlFor="free">
                      Free of Cost
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="price"
                      id="paid"
                      value="paid"
                    />
                    <label className="form-check-label" htmlFor="paid">
                      Paid
                    </label>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="form-label">Per Person Price: </label>
                  <span className="fw-bold text-primary">120 $</span>
                </div>
              </div>

              {/* Description Section */}
              <div className="mb-4">
                <label htmlFor="description" className="form-label" style={{paddingBottom:'6px'}}>
                  Description
                </label>
                <textarea
                  style={{ minHeight: '108px' }}
                  className="form-control"
                  id="description"
                  rows="3"
                  placeholder="Enter description here"
                  defaultValue="Tennis is a fast-paced, competitive sport played between two or four players using rackets to hit a ball over a net on a rectangular court"
                ></textarea>
              </div>

              {/* Players Section */}
              <div className="mb-4">
                <label className="form-label">Players</label>
                <p className="mb-1">Participants: 2 OUT OF 2</p>
                <ul className="list-group">
                  <li className="list-group-item d-flex align-items-center">
                    <img
                      src={man}
                      alt="Jhon"
                      className="rounded-circle me-3"
                      style={{ width: "40px", height: "40px" }}
                    />
                    <div className="flex-grow-1">
                      <strong>Jhon g</strong> <span className="text-muted">(Expert)</span>
                    </div>
                  <img src={ message}/>
                  </li>
                  <li className="list-group-item d-flex align-items-center">
                    <img
                      src={man}
                      alt="Tony"
                      className="rounded-circle me-3"
                      style={{ width: "40px", height: "40px" }}
                    />
                    <div className="flex-grow-1">
                      <strong>tony k</strong> <span className="text-muted">(Beginner)</span>
                    </div>
                    <img src={ message}/>
                  </li>
                </ul>
              </div>

              {/* No Spots Available Toggle */}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="noSpotsAvailable"
                />
                <label className="form-check-label" htmlFor="noSpotsAvailable">
                  Mark as "No Spots Available"
                </label>
              </div>

              {/* Additional Question */}
              <p className="text-danger" onClick = {onNotJoinedSubmission}>Who did not join court?</p>

          
                <CustomButton
                    buttonText={'Save'}
                    className="border"
                    style={{
                        width: '100%',
                        height: '48px',
                        borderRadius: '12px',
                        background: '#006FFD',
                        color: '#FFFFFF',
                        marginTop:'45px'
                    }}
                />
            </form>
    </Layout>
   { isNotJoinedSubmission && <NotJoinedSubmission/>}
      </>
  );
};

export default JoinedPlayerList;
